import React, {FC} from 'react';
import { useTranslation } from 'react-i18next';

import ProviderSecurityTable from "./ProviderSecurityTable";

const ProviderSecurityMapping: FC<{ accessToken: string }> = ({ accessToken }) => {
  const { t } = useTranslation();

  return (
    <div className="provider-security-mapping">
      <h2 className="tab-heading">{t('admin.task.provider.mapping')}</h2>
      <ProviderSecurityTable accessToken={accessToken} />
    </div>
  );
};

export default ProviderSecurityMapping;
